var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 3.83335C6.31843 3.83335 3.33366 6.81812 3.33366 10.5C3.33366 14.1819 6.31843 17.1667 10.0003 17.1667C13.6822 17.1667 16.667 14.1819 16.667 10.5C16.667 6.81812 13.6822 3.83335 10.0003 3.83335ZM1.66699 10.5C1.66699 5.89765 5.39795 2.16669 10.0003 2.16669C14.6027 2.16669 18.3337 5.89765 18.3337 10.5C18.3337 15.1024 14.6027 18.8334 10.0003 18.8334C5.39795 18.8334 1.66699 15.1024 1.66699 10.5ZM10.0003 6.33335C10.4606 6.33335 10.8337 6.70645 10.8337 7.16669V10.1548L13.0896 12.4108C13.415 12.7362 13.415 13.2638 13.0896 13.5893C12.7641 13.9147 12.2365 13.9147 11.9111 13.5893L9.41107 11.0893C9.25479 10.933 9.16699 10.721 9.16699 10.5V7.16669C9.16699 6.70645 9.54009 6.33335 10.0003 6.33335Z",
    fill: "#E9ECF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7903393da4a7980056815fd9fd55876d.svg";
export { ForwardRef as ReactComponent };